import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles((theme) => ({
  verticalGroup: {
    display: "flex",
    gap: theme.spacing(1),
    flexDirection: "column",
  },
  overwriteCashbackTagStyle: {
    padding: theme.spacing(0.5, 0),
  },
  campaignTermsModal: {},
  breadcrumbs: {
    marginTop: 15,
    padding: 8,
  },
  breadcrumbLink: {
    cursor: "pointer",
    fontWeight: "bold",
  },
  breadcrumbCurrent: {
    fontSize: 12,
  },
})); 